import React from 'react';
import {
  Box,
  Typography,
  Button,
  Card,
  CardContent,
  Grid,
  Divider,
  List,
  ListItem,
  ListItemText,
  Paper
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { registrationData } from '../data/registrationData';

const Summary = ({ formData, onEdit, onSubmit, isSubmitting }) => {
  const { nationality, conferenceType, delegateType } = formData;
  const price = registrationData[nationality][conferenceType].onsite[delegateType];
  const currency = nationality === 'indian' ? 'INR' : 'USD';

  const formattedPrice = price === 0 ? '0' : price?.toLocaleString();

  const renderSection = (title, fields) => (
    <Card variant="outlined" sx={{ mb: 3, bgcolor: 'background.paper' }}>
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: 'primary.main' }}>
            {title}
          </Typography>
          <Button 
            startIcon={<EditIcon />} 
            onClick={onEdit}
            size="small"
            sx={{ textTransform: 'none' }}
          >
            Edit
          </Button>
        </Box>
        
        <List disablePadding>
          {fields.map(([label, value]) => (
            <ListItem key={label} disablePadding sx={{ py: 0.5 }}>
              <ListItemText
                primary={
                  <Grid container spacing={2}>
                    <Grid item xs={5} sm={4}>
                      <Typography variant="body2" color="text.secondary">
                        {label}
                      </Typography>
                    </Grid>
                    <Grid item xs={7} sm={8}>
                      <Typography variant="body2" fontWeight="medium">
                        {value}
                      </Typography>
                    </Grid>
                  </Grid>
                }
              />
            </ListItem>
          ))}
        </List>
      </CardContent>
    </Card>
  );

  return (
    <Box>
      {renderSection('Registration Details', [
        ['Nationality', nationality === 'indian' ? 'Indian' : 'International'],
        ['Conference Type', conferenceType === 'mainConference' 
          ? 'Main Conference (5th & 6th April, 2025)' 
          : 'Full Conference (4th to 6th April, 2025)'],
        ['Delegate Type', delegateType]
      ])}
      
      {renderSection('Personal Information', [
        ['Name', `${formData.firstName} ${formData.lastName}`],
        ['Email', formData.email],
        ['Phone', formData.phone],
        ['Institution', formData.institution]
      ])}
      
      {renderSection('Address Information', [
        ['Address', formData.address],
        ['City', formData.city],
        ['State', formData.state],
        ['Country', formData.country],
        ['Postal Code', formData.postalCode]
      ])}
      
      <Paper 
        elevation={3} 
        sx={{ 
          p: 3, 
          mt: 4, 
          bgcolor: 'primary.light', 
          color: 'primary.contrastText',
          borderRadius: 2
        }}
      >
        <Typography variant="h6" gutterBottom>
          Payment Summary
        </Typography>
        <Divider sx={{ my: 1, borderColor: 'rgba(255,255,255,0.2)' }} />
        
        <Box sx={{ display: 'flex', justifyContent: 'space-between', my: 2 }}>
          <Typography variant="body1">Registration Fee:</Typography>
          <Typography variant="body1" fontWeight="bold">
            {currency} {formattedPrice}
          </Typography>
        </Box>
        
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
          <Typography variant="h6">Total Amount:</Typography>
          <Typography variant="h6" fontWeight="bold">
            {currency} {formattedPrice}
          </Typography>
        </Box>
      </Paper>
      
      <Box sx={{ mt: 4, textAlign: 'center' }}>
        <Button
          variant="contained"
          color="primary"
          onClick={onSubmit}
          disabled={isSubmitting}
          size="large"
          sx={{ 
            px: 4,
            borderRadius: 2,
            textTransform: 'none',
            fontWeight: 'medium',
            boxShadow: 2
          }}
        >
          {isSubmitting ? 'Submitting...' : 'Complete Registration'}
        </Button>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          By clicking "Complete Registration", you agree to our Terms and Conditions.
        </Typography>
      </Box>
    </Box>
  );
};

export default Summary; 